module.exports = __webpack_public_path__ + "static/img/friend13.b42fd4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend13.jpg
// module id = QmXB
// module chunks = 1